import {useState} from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../Icons/menu/Icon";
import About from "../../about";
import WorkPlaces from "../../workplaces";
import Officesetting from "../../officesetting";
import { ErrorContext } from "../../../utils/context/error";
import { getUserxId } from "../../../services/user";

function Navbar() {
  const [show, handleshow]=useState(false);
  const [showC, handleshowC]=useState(false);
  const [showA, handleshowA]=useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  let PersonalId=0;
  
  const navigate = useNavigate()
  const Logout =() =>{
     localStorage.removeItem('1dTkApp');
     navigate('/');
  }
  //-----
  const Handleworplace = async ()=>
    {
       const response = await getUserxId();
       if (response)
        {
          if (response.status === 200) 
           {
             PersonalId = response.data.data.PersonalId;
           } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
        
        if ([1, 2, 3, 4].includes(PersonalId)) 
          handleshowC(true)
        else     
           handleshow(true);
   }
 //---
  const HandleAbout =()=>
    {
      handleshowA(true);
    }
  
  return (
    <>
    <div className="h-[3rem] bg-light border-b-[0.1rem] border-border">
      <div className="h-[3rem] flex justify-end mr-[2rem] items-end">
      <ul className="flex space-x-4 mb-[0.5rem]">
          <li onClick ={Handleworplace}>
              <i>
                <Icon svg="usercog" className="w-5 h-5 fill-current text-border hover:text-default hover:cursor-pointer" title="terminal" />
              </i>
          </li>
          <li>
            <i onClick ={HandleAbout}>
                <Icon svg="infoCircle" className="w-5 h-5 fill-current text-border hover:text-default hover:cursor-pointer" title="info" />
            </i>
          </li>
          <li onClick ={Logout}>
            <i>
              <Icon svg="RightToBracket" className="w-5 h-5 fill-current text-border hover:text-default hover:cursor-pointer" title="RightToBracket"/>
            </i>
          </li>
        </ul>
      </div>
    </div>
    {show ?
    (<WorkPlaces show={show} handleshow= {handleshow}></WorkPlaces> ):('')}
    
    {showC ?
    (<Officesetting show={showC} handleshow= {handleshowC}></Officesetting> ):('')}
  
    {showA ?
    (<About show={showA} handleshow= {handleshowA}></About> ):('')}  
  </>  
  );
  
}
export default Navbar;
